import React from "react";
import { McIcon } from "@maersk-global/mds-react-wrapper/icons";
import { CHAT_CONSTANTS } from "../../../constants/constants";
import { useStore } from "../../../store/store.context";

import "./chat-header.scss";

const ChatHeader = () => {
  const { store, updateStore } = useStore();
  const { showMessagePanel } = store;

  return (
    <>
      <div className="chat-header">
        <p className="chat-header-title">{CHAT_CONSTANTS.CHAT_HEADING_NAME}</p>
        <div className="chat-close-icon">
          <McIcon
            icon="double-chevron-left"
            size="16"
            onClick={() => updateStore({ showMessagePanel: !showMessagePanel })}
          />
        </div>
      </div>
      <div className="chat-header-divider" />
    </>
  );
};

export default ChatHeader;
